import React, { useState } from "react"
import tw, { styled } from "twin.macro"
import { useInterval } from "../../../utils/custom-hooks"

const Carousel = ({ items, ...props }) => {
  const [slide, setSlide] = useState(0)

  const interval = useInterval(() => {
    setSlide(slide + 1 >= items.length ? 0 : slide + 1)
  }, props.timeout)

  return items.length > 0 ? (
    <Style className="carousel" {...props}>
      <div className="carousel__inner">
        <CarouselStyle className="carousel__list">
          {items.map((item, i) => (
            <li key={i} className={slide === i ? "is-active" : null}>
              {item}
            </li>
          ))}
        </CarouselStyle>
        {items.length > 1 && (
          <div className="carousel__indicators">
            {items.map((item, i) => (
              <button
                type="button"
                onClick={() => {
                  setSlide(i)
                  clearInterval(interval)
                }}
                key={i}
                disabled={slide === i}
              >
                {i}
              </button>
            ))}
          </div>
        )}
      </div>
    </Style>
  ) : null
}

Carousel.defaultProps = {
  timeout: 5000,
  items: [],
}

const Style = styled.div`
    > .carousel__inner {
        ${tw`h-full sm:max-w-md mg:max-w-xl bg-black bg-opacity-60 text-white py-8 relative flex flex-col justify-center gap-y-4 md:gap-y-8`}

        &::before {
            ${tw`content w-screen bg-black bg-opacity-60 h-full absolute top-0 left-0 `}
            transform: translateX(-100%);
        }
    }

    .carousel__indicators {
        ${tw`flex z-20 justify-center gap-x-3 items-center sm:justify-start`}


        > button {
            ${tw`appearance-none w-3 h-3 outline-none border-none p-0 rounded-full block bg-silver cursor-pointer`}
            text-indent: -5000em;
            overflow: hidden;
            transition: background-color: .45s ease;
        
            &:disabled {
                ${tw`bg-primary cursor-default`}
            }
        }
    }

`

const CarouselStyle = styled.ol`
  ${tw`list-none p-0 m-0 grid h-auto md:w-4/5`}
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;

  > li {
    margin-bottom: 0;
    grid-row: 1 / 2;
    grid-column: 1 / 2;
    z-index: -1;
    position: relative;
    height: auto; // 0
    opacity: 0;
    transition: opacity 0.65s ease;
    ${tw`h-auto`}

    &.is-active {
      opacity: 1;
      z-index: 2;
      height: auto;
    }
  }
`

export default Carousel
